import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { Slot } from '@cmpkit/utils';
const NavItem = React.forwardRef((_a, ref) => {
    var { className, as: Component = 'div', active, disabled, children, icon, asChild } = _a, props = __rest(_a, ["className", "as", "active", "disabled", "children", "icon", "asChild"]);
    const Comp = asChild ? Slot : Component;
    return (React.createElement(Comp, Object.assign({ ref: ref, role: 'button' }, props, { className: clsx('cmp-nav-item', className, {
            active,
            disabled,
            icon,
        }) }), children));
});
NavItem.displayName = 'NavItem';
export { NavItem };
//# sourceMappingURL=NavItem.js.map